<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>其他任务配置</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <ClearCacheApply />
              <sync-data />
            </el-col>
          </el-row>
        </div>
        <el-form class="demo-form-inline">
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="12">
              <el-form-item>
                <div class="task-item">
                  <div class="task-title">VS方块任务</div>
                  <div class="tag-input-wrapper">
                    <span class="task-label">任务目标：</span>
                    <el-tag
                      v-for="(tag, index) in vsTaskBlockTags"
                      :key="index"
                      closable
                      :disable-transitions="false"
                      class="task-tag"
                      @close="removeVsTag(index)"
                    >
                      {{ tag }}
                    </el-tag>
                    <el-input
                      v-model="vsTaskBlockInput"
                      style="width: 150px;"
                      placeholder="输入数字回车添加"
                      @keyup.enter.native="addVsTag"
                      @blur="addVsTag"
                    />
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <div class="task-item">
                  <div class="task-title">问号方块任务</div>
                  <div class="tag-input-wrapper">
                    <span class="task-label">任务目标：</span>
                    <el-tag
                      v-for="(tag, index) in questionTaskBlockTags"
                      :key="index"
                      closable
                      :disable-transitions="false"
                      class="task-tag"
                      @close="removeQuestionTag(index)"
                    >
                      {{ tag }}
                    </el-tag>
                    <el-input
                      v-model="questionTaskBlockInput"
                      style="width: 150px;"
                      placeholder="输入数字回车添加"
                      @keyup.enter.native="addQuestionTag"
                      @blur="addQuestionTag"
                    />
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button type="primary" @click="onSubmit()">保存</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { updateTaskCfg, getTaskCfg } from '@/api/config/tetris/task'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'TetrisTask',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      otherData: {
        vs_task_block: '',
        question_task_block: ''
      },
      vsTaskBlockInput: '',
      questionTaskBlockInput: '',
      vsTaskBlockTags: [],
      questionTaskBlockTags: []
    }
  },
  created() {
    this.getCfg()
  },
  methods: {
    getCfg() {
      getTaskCfg().then(res => {
        this.otherData = res.data || {
          vs_task_block: '',
          question_task_block: ''
        }
        this.initTags()
      })
    },
    initTags() {
      this.vsTaskBlockTags = this.otherData.vs_task_block ? this.otherData.vs_task_block.split(',') : []
      this.questionTaskBlockTags = this.otherData.question_task_block ? this.otherData.question_task_block.split(',') : []
    },
    addVsTag() {
      const val = this.vsTaskBlockInput.trim()
      if (val && !isNaN(val)) {
        this.vsTaskBlockTags.push(val)
      }
      this.vsTaskBlockInput = ''
    },
    removeVsTag(index) {
      this.vsTaskBlockTags.splice(index, 1)
    },
    addQuestionTag() {
      const val = this.questionTaskBlockInput.trim()
      if (val && !isNaN(val)) {
        this.questionTaskBlockTags.push(val)
      }
      this.questionTaskBlockInput = ''
    },
    removeQuestionTag(index) {
      this.questionTaskBlockTags.splice(index, 1)
    },
    onSubmit() {
      this.otherData.vs_task_block = this.vsTaskBlockTags.join(',')
      this.otherData.question_task_block = this.questionTaskBlockTags.join(',')
      updateTaskCfg({ data: JSON.stringify(this.otherData) }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.tag-input-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-height: 32px;
  padding: 4px 0;
}
.task-tag {
  margin-right: 0;
}
.task-label {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}
.task-item {
  width: 100%;
}
.task-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 10px;
}
</style>
